import React from 'react';
import { withRouter } from '../../util/withRouter';
import withStyles from '@mui/styles/withStyles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { compose } from '../../reactApolloCompat';

class SortDropdown extends React.Component {
    handleChange = event => {
        this.props.setSortField(event.target.value);
    };

    options = [
        { field: '', direction: '', label: 'Relevance' },
        { field: 'LastEdited', direction: 'DESC', label: 'Recently updated' },
        { field: 'Created', direction: 'DESC', label: 'Recently created' },
        { field: 'Name', direction: 'ASC', label: 'Business Name' },
        { field: 'Contact', direction: 'ASC', label: 'Contact Person' }
    ];

    render() {
        const { classes, sortField, sortDirection } = this.props;
        const selected = this.options.find(obj => {
            return obj.field === sortField;
        });
        return (
            <Select
                value={sortField + sortDirection}
                onChange={this.handleChange}
                displayEmpty
                name="sortField"
                className={classes.select}
            >
                {selected && sortField && (
                    <MenuItem value={sortField + (selected.direction === 'ASC' ? 'DESC' : 'ASC')}>
                        {selected.label} (reverse)
                    </MenuItem>
                )}
                {this.options.map((obj, i) => {
                    return (
                        <MenuItem key={i} value={obj.field + obj.direction}>
                            {obj.label}
                        </MenuItem>
                    );
                })}
            </Select>
        );
    }
}

const styles = ({ typography }) => ({
    select: {
        minWidth: 150,
        width: 200,
        marginBottom: -4,
        '&>div>div': {
            paddingLeft: 6
        }
    }
});

export default compose(withRouter, withStyles(styles))(SortDropdown);
